<!--
  A picture of a question page as a mentor sees it before they publish: their
  own answer in full, and the answers of two other mentors blurred behind a
  lock. It shows an example and does nothing.
-->
<template>
  <div
    class="rounded-2xl bg-neutral-50 px-4 py-5 sm:px-6 sm:py-6"
    aria-hidden="true"
  >
    <div class="mx-auto max-w-[330px] space-y-2 text-left">
      <div
        class="flex items-start gap-2.5 rounded-2xl bg-white p-3.5 shadow-[0_14px_34px_rgba(20,31,47,0.16)]"
      >
        <span
          class="bg-secondary-600 grid size-9 shrink-0 place-items-center rounded-full text-white"
        >
          <QuoteIcon class="size-4" />
        </span>
        <div class="min-w-0 flex-1">
          <div class="text-[13px] font-semibold text-neutral-900">
            Your answer
          </div>
          <div class="mt-0.5 text-xs leading-snug text-neutral-600">
            What you told a founder on a call, in your own words.
          </div>
        </div>
      </div>
      <div
        v-for="avatar in OTHERS"
        :key="avatar"
        class="flex items-start gap-2.5 rounded-2xl bg-white p-3.5 shadow-[0_6px_18px_rgba(20,31,47,0.08)]"
      >
        <img
          :src="avatar"
          alt=""
          width="36"
          height="36"
          class="size-9 shrink-0 rounded-full bg-neutral-100 object-cover"
        />
        <div class="min-w-0 flex-1">
          <div class="text-[13px] font-semibold text-neutral-900">
            Another mentor
          </div>
          <div
            class="mt-0.5 text-xs leading-snug text-neutral-600 blur-[4px] select-none"
          >
            A different stand on the same question, said to another founder.
          </div>
        </div>
        <LockIcon class="mt-0.5 size-4 shrink-0 text-neutral-500" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LockIcon from '~icons/lucide/lock'
import QuoteIcon from '~icons/lucide/message-square-quote'

const OTHERS = ['/avatars/female/10.png', '/avatars/male/3.png']
</script>
